<template>
    <div class="StudentManagement">
        <!-- 移动端返回 -->
        <div class="mobileReturn">
            <img src="../../assets/img/nav_return.svg" @click="toReturn"/>
            <p>学时管理</p>
        </div>
        <div class="otherWrap">
            <h3 class="xsgl">学时管理</h3>
            <!-- 搜索 -->
            <div class="courseSearchWrap">
                <div class="condition">
                    <div class="TextInputBox">
                        <el-input v-model="departmentVal" placeholder="全部部门"></el-input>
                    </div>
                    <div class="courseNameBox">
                        <el-input v-model="nameVal" placeholder="姓名"></el-input>
                    </div>
                </div>
                <div class="dateBox">
                    <el-date-picker
                        v-model="beginTime"
                        type="date"
                        :clearable="false"
                        value-format="yyyy-MM-dd"
                        placeholder="开始日期"
                        :picker-options="pickerOptions0">
                    </el-date-picker>
                    <span class="toDate">至</span>
                    <el-date-picker
                        v-model="endTime"
                        type="date"
                        :clearable="false"
                        value-format="yyyy-MM-dd"
                        placeholder="结束日期"
                        :picker-options="pickerOptions1">
                    </el-date-picker>
                </div>
                <div class="query-clear">
                    <span class="searchSty" @click="queryDepartmentTime">查询</span>
                    <span @click="clearMemberVal">清空</span>
                </div>
            </div>            
        </div>
        <!-- 列表头 -->
        <ul class="listTitleWrap">
            <li>
                <span class="name">姓名</span>
                <span class="departmentText">部门</span>
                <span class="typeText">岗位类型</span>
                <span class="typeText">人员类型</span>
                <span class="totalTime">累计时长</span>
            </li>
        </ul>
        <!-- 移动端列表头 -->
        <div class="mobileListTitle">
            <p>姓名 | 排名</p>
            <p>部门</p>
            <p>累计时长</p>
        </div>
        <!-- 列表内容 -->
        <ul class="listContWrap">
            <li v-for="(item,index) in studentList" :key="index" @click="openInfo(item.RealName,item.DeptName,item.MemberID)">
                <p class="name"><span>{{(page-1)*pagesize+index+1}}</span><span>{{item.RealName}}</span></p>
                <p class="departmentText">{{item.DeptName}}</p>
                <p class="typeText">{{item.JobType}}</p>
                <p class="typeText">{{item.Party}}</p>
                <p class="totalTime">{{item.KeepSec | formatData}}</p>
            </li>
        </ul>
        <!-- 分页器 -->
        <div class="page"><Pagination :total='totalPage' :page="page" :pageSize='pagesize' @currentPage="currentPage"></Pagination></div>
        <!-- 移动端查看更多 -->
        <p class="moreCourse" v-if="isShowMemberMore" @click="getMemberMore">查看更多</p>
        <!-- 个人资料查询 -->
        <div class="personInfoCover" v-if="isShowInfo" @click.self="closeInfo">
            <div class="personInfoWrap">
                <div class="otherWrap">
                    <h3>学时统计</h3>
                    <!-- 学习信息 -->
                    <div class="timeWrap">
                        <p>{{departmentName}}</p>
                        <p class="xxtjName">{{memberName}}</p>
                        <p>本年度时长：{{annuaDuration | formatData}}</p>
                    </div>
                    <!-- 学时时间段 -->
                    <p class="timeSlot" v-show="beginTime!='' || endTime!=''">{{beginTime+' 至 '+endTime}}</p>
                </div>
                <!-- 移动端表头 -->
                <div class="infoListTitle">
                    <span>课程名称</span>
                    <span>学时</span>
                </div>
                <!-- 列表 -->
                <ul class="infoList" v-infinite-scroll="loadList" :infinite-scroll-disabled="noMore">
                    <li v-for="(item,index) in infoList" :key="index">
                        <div class="courseWrap" @click="showSubCourse(index)">
                            <span>{{item.Title}}</span>
                            <span>{{item.KeepSec | formatData}}</span>
                            <div class="blueArrow">
                                <img src="../../assets/img/blueArrow.png"  :class="showCourseList == index?'blueTopArrow':'blueNormalArrow'">
                            </div>
                        </div>
                        <el-collapse-transition>
                            <ul v-show="showCourseList == index">
                                <li v-for="(it,ind) in item.Items" :key="ind">
                                    <span>{{it.Title}}</span>
                                    <span>{{it.KeepSec | formatData}}</span>
                                </li>
                            </ul>
                        </el-collapse-transition>
                    </li>
                </ul>
                <p class="load" v-show="loading">加载中...</p>
                <p class="load" v-show="noMore">没有更多了</p>
                <!-- 分页器 -->
                <div class="page" ref="page"><Pagination :total='courseTotalPage' :page="coursePage" :pageSize="pagesize" @currentPage="courseCurrentPage"></Pagination></div>
                <!-- 关闭 -->
                <div class="close" @click="closeInfo"></div>
            </div>
        </div>
    </div>
</template>

<script>
import Pagination from '../../components/Pagination'
export default {
    data() {
        return {
            beginTime:'',  // 开始时间
            endTime:'',  // 结束时间
            pickerOptions0: {
                disabledDate: (time) => {
                    if (this.endTime != "") {
                        return time.getTime() > Date.now() || time.getTime() > this.endTime;
                    } else {
                        return time.getTime() > Date.now();
                    }

                }
            },
            pickerOptions1: {
                disabledDate: (time) => {
                    return time.getTime() < this.beginTime || time.getTime() > Date.now();
                }
            },
            nameVal:'',  // input值-查询名字
            departmentVal:'',  // 部门
            studentList:[],  // 学员列表
            totalPage:0,  // 总页数
            page:1,  // 页数
            pagesize:9,  // 多少条数据
            infoList:[],  // 学员课程列表
            memberId:undefined,  // 学员id
            memberName:'',  // 学员姓名
            departmentName:'',  // 部门
            annuaDuration:0,  // 年度时长
            courseTotalPage:0,  // 学员课程列表总数
            coursePage:1,   // 学员课程列表当前页
            isShowInfo:false,  // 展开详情
            showCourseList:-1,  // 列表的展开收起
            isShowMemberMore:true,  // 学员列表的查看更多
            loading:false,  // 移动端控制加载中的显示
            isQuery:false  // 是否查询过
        }
    },
    mounted(){
        // 获取学员列表
        this.getConditionList();
    },
    methods: {
        // 获取查询条件的列表
        getConditionList(type){
            // 时间段格式
            let timeSlot = "";
            if(this.beginTime == "" || this.endTime == ""){
                timeSlot = "";
            }else{
                timeSlot = this.beginTime + '_' + this.endTime;
            }

            let timestamp = Date.parse(new Date())/1000;
            let data = {
                "TimeStamp":timestamp, 
                "PageSize":this.pagesize,
                "CurPage":this.page,
                "Query": [
                    { "Item": "Name", "Value": this.nameVal },
                    { "Item": "Dept", "Value": this.departmentVal },
                    { "Item": "DateRange", "Value": timeSlot }
                ]
            }
            this.$axios.post(Const_Api_Root+'api/AdminCenter/MemberPeriodAccount',data,{
                contentType: 'application/json',
                dateType:'JSON',
                xHrFields: {withCredentials:true},
				beforeSend: function (XHR) {
					XHR.withCredentials = true;  // 跨域cookie支持代码
				}
            }).then((res)=>{
                // 错误提示
                if(res.data.Status == 0){
                    this.totalPage = res.data.Data.Total;
                    if(type == 'more'){
                        // 移动端的操作
                        this.studentList = this.studentList.concat(res.data.Data.Rows);
                    }else{
                        // 列表
                        this.studentList = res.data.Data.Rows;
                    }

                    // 是否显示查看更多
                    if(this.totalPage != this.studentList.length){
                        this.isShowMemberMore = true;
                    }else{
                        this.isShowMemberMore = false;
                    }
                }else if(res.data.Status != -2){
                    this.$message({
                        message: res.data.Data,
                        type: 'error',
                        duration: 3000
                    });
                }
            }).catch((err)=>{
                throw err;
            });
        },
        // 学员课程学时查询
        queryDepartmentTime(){
            if(this.departmentVal=="" && this.beginTime=="" && this.endTime=="" && this.nameVal=="") return;
            
            this.page = 1;
            this.getConditionList();
            this.isQuery = true;
        },
         // 学员列表分页器
        currentPage(index){
            this.page = index;
            // 获取学员列表
            this.getConditionList();
        },
        // 学员列表查看更多
        getMemberMore(){
            this.page++;
            // 获取学员列表
            this.getConditionList('more');
        },
        // 学员具体信息分页器
        courseCurrentPage(index){
            this.coursePage = index;
            this.showCourseList = -1;

            this.getMemberCourses();
        },
        // 打开个人资料页
        openInfo(name,dept,id){
            this.isShowInfo = true;
            this.memberId = id;
            this.memberName = name;
            this.departmentName = dept;

            // 学员课程列表
            this.getMemberCourses();
            // 获取本年度学时
            this.getMemberScores();
        },
        // 获取学员课程列表
        getMemberCourses(type){
            // 时间段格式
            let timeSlot = "";
            if(this.beginTime == "" || this.endTime == ""){
                timeSlot = "";
            }else{
                timeSlot = this.beginTime + '_' + this.endTime;
            }

            let timestamp = Date.parse(new Date())/1000;
            let data = {
                "TimeStamp":timestamp,
                "PageSize":this.pagesize,
                "CurPage":this.coursePage,
                "Query": [
                    { "Item": "MemID", "Value": this.memberId },
                    { "Item": "DateRange", "Value": timeSlot }
                ]
            }
            this.$axios.post(Const_Api_Root+'api/AdminCenter/MemberPeriodDetail',data,{
                contentType: 'application/json',
                dateType:'JSON',
                xHrFields: {withCredentials:true},
				beforeSend: function (XHR) {
					XHR.withCredentials = true;  // 跨域cookie支持代码
				}
            }).then((res)=>{
                // 错误提示
                if(res.data.Status == 0){
                    this.courseTotalPage = res.data.Data.Total;
                    if(type == 'more'){
                        this.infoList = this.infoList.concat(res.data.Data.Rows);
                    }else{
                        this.infoList = res.data.Data.Rows;
                    }
                }else if(res.data.Status != -2){
                    this.$message({
                        message: res.data.Data,
                        type: 'error',
                        duration: 3000
                    });
                }
            }).catch((err)=>{
                throw err;
            });
        },
        // 获取课时统计
        getMemberScores(){
            let timestamp = Date.parse(new Date())/1000;
            let data = {
                "TimeStamp":timestamp,
                "ID":this.memberId
            }
            this.$axios.post(Const_Api_Root+'api/AdminCenter/MemberScores',data,{
                contentType: 'application/json',
                dateType:'JSON',
                xHrFields: {withCredentials:true},
				beforeSend: function (XHR) {
					XHR.withCredentials = true;  // 跨域cookie支持代码
				}
            }).then((res)=>{
                // 错误提示
                if(res.data.Status == 0){
                    this.annuaDuration = res.data.Data.CurSec;
                }else if(res.data.Status != -2){
                    this.$message({
                        message: res.data.Data,
                        type: 'error',
                        duration: 3000
                    });
                }
            }).catch((err)=>{
                throw err;
            });
        },
        // 列表的展开收起
        showSubCourse(n){
            if(n == this.showCourseList){
                this.showCourseList = -1;
            }else{
                this.showCourseList = n;
            }
        },
        // 清空关于学员的查询值
        clearMemberVal(){
            this.departmentVal = '';
            this.nameVal = '';
            this.beginTime = '';
            this.endTime = '';

            // 如果用户将值清空，就显示全部数据
            if(!this.isQuery) return;
            this.page = 1;
            this.getConditionList();
        },
        // 关闭
        closeInfo(){
            this.isShowInfo = false;
            this.coursePage = 1;
            this.showCourseList = -1;
        },
        // 返回
        toReturn(){
            // window.history.go(-1);
            this.$router.push({path: '/index'});
        },
        // 移动端加载列表
        loadList(){
            this.loading = true
            setTimeout(() => {
                this.coursePage++;
                this.getMemberCourses('more');
                this.loading = false;
            }, 1000);
        }
    },
    computed: {
        noMore () {
            if(window.innerWidth >= 320&&window.innerWidth <= 1024){
                return this.infoList.length >= this.courseTotalPage;
            }else{
                return true
            } 
            
        },
        disabled () {
            return this.loading || this.noMore
        }
    },
    filters: {
        // 格式化时间
        formatData:(value) => {
            let result = parseInt(value)
            let h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600);
            let m = Math.floor((result / 60 % 60)) < 10 ? '0' + Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60));
            let s = Math.floor((result % 60)) < 10 ? '0' + Math.floor((result % 60)) : Math.floor((result % 60));
            value = h+':'+m+':'+s;
            return value;
        }
    },
    components: {
        Pagination
    }
}
</script>

<style scoped lang="less">
@media screen and (min-width: 320px) and (max-width: 1024px){
    .StudentManagement{
        width: 100%;
        padding: 0 17px;
    }
    .listTitleWrap,.page,.typeText,.xsgl{
        display: none;
    }
    // 查看更多
    .moreCourse{
        font-size: 14px;
        color: #0061FE;
        text-align: center;
        font-weight: bold;
        padding: 20px 0;
    }
    // 返回
    .mobileReturn{
        width: 100%;
        height: 60px;
        display: flex;
        align-items: center;

        position: relative;
        p{
            font-size: 14px;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);
        }
        img{
            width: 30px;
            height: 30px;
        }
    }
    // 列表
    .mobileListTitle{
        display: flex;
        align-items: center;
        margin-bottom: 12px;
        width: 100%;
        p{
            font-size: 12px;
            color: rgba(25,25,26,0.80);
            &:first-child{
                width: 25%;
            }
            &:nth-child(2){
                width: 45%;
            }
            &:last-child{
                width: 30%;
                text-align: right;
            }
        }
    }
    // 列表内容
    .listContWrap{
        width: 100%;
        li{
            display: flex;
            align-items: center;
            font-size: 14px;
            padding: 14px 0;
            border-bottom: 2px solid #fafafa;
        }
        .departmentText{
            width: 45%;
        }
        .totalTime{
            width: 30%;
            text-align: right;
        }
        .name{
            width: 25%;
            display: flex;
            flex-direction: column-reverse;
            span:first-child{
                margin-top: 7px;
                font-size: 12px;
                color: rgba(25,25,26,0.80);
            }
        }
    }
    // 个人资料查询
    .personInfoCover{
        width: 100%;
        height: 100%;
        padding: 0 17px;
        background: rgba(0,0,0,0.40);
        display: flex;
        align-items: center;
        justify-content: center;
    
        position: fixed;
        top: 0;
        left: 0;
        h3{
            text-align: center;
            font-size: 14px;
            line-height: 50px;
            width: 100%;
            border-bottom: 2px solid #fafafa;
        }
        .timeWrap{
            width: 100%;
            display: flex;
            justify-content: space-around;
            align-items: center;
			flex-wrap: wrap;
            margin: 10px 0;
            p{
                color: rgba(25,25,26,0.80);
                font-size: 14px;
            }
        }
        .timeSlot{
            text-align: center;
            color: #19191a;
            font-size: 14px;
            margin-bottom: 10px;
        }
        .personInfoWrap{
            width: 100%;
            box-sizing: border-box;
            background-color: #fff;
            border-radius: 16px;
            padding: 0 16px;
            min-height: 500px;
    
            position: relative;
        }
        // 表头
        .infoListTitle{
            display: flex;
            padding-bottom: 10px;
            border-bottom: 2px solid #fafafa;
            font-size: 12px;
            color: rgba(25,25,26,0.80);
            span:first-child{
                width: 75%;
            }
            span:last-child{
                width: 15%;
            }
        }
        // 学院课程列表
        .infoList{
            max-height: 320px;
            overflow: hidden;
            overflow-y: scroll;
            margin-bottom: 10px;
            .courseWrap{
                padding: 10px 0;
                display: flex;
                align-items: center;
                border-bottom: 2px solid #fafafa;
            }
            span:first-child{
                font-size: 14px;
                width: 75%;
            }
            span:nth-child(2){
                font-size: 12px;
                color: rgba(25,25,26,0.80);
                width: 20%;
            }
            .blueArrow{
                width: 5%;
                vertical-align: middle;
            }
            .blueNormalArrow{
                transition: 0.5s;
                transform:rotate(0);
                -ms-transform:rotate(0); 	/* IE 9 */
                -moz-transform:rotate(0); 	/* Firefox */
                -webkit-transform:rotate(0); /* Safari 和 Chrome */
                -o-transform:rotate(0); 	/* Opera */
            }
            .blueTopArrow{
                transition: 0.5s;
                transform:rotate(180deg);
                -ms-transform:rotate(180deg); 	/* IE 9 */
                -moz-transform:rotate(180deg); 	/* Firefox */
                -webkit-transform:rotate(180deg); /* Safari 和 Chrome */
                -o-transform:rotate(180deg); 	/* Opera */
            }
            .credit{
                font-size: 18px;
            }
            ul{
                padding: 0 0 10px 15px;
                border-bottom: 2px solid #fafafa;
                li{
                    display: flex;
                    padding: 10px 0 0;
                }
                span:first-child{
                    width: 75%;
                }
                span:last-child{
                    text-align: left;
                    width: 25%;
                }
            }
        }
        // 关闭
        .close{
            width: 20px;
            height: 20px;
            background: url('../../assets/img/delete_icon.svg') no-repeat center;
            background-size: 100%;
            cursor: pointer;
    
            position: absolute;
            top: 13px;
            right: 17px;
        }
    }
    // 查询
    .courseSearchWrap{
        width: 100%;
        margin: 0 auto;
        .condition{
            margin-top: 10px;
            display: flex;
        }
        .TextInputBox{
            margin-right: 5px;
        }
        .dateBox{
            display: flex;
            align-items: center;
            margin: 10px 0;
        }
        .searchSty{
            color: #0061fe;
        }
    }
    .query-clear {
        margin-bottom: 10px;
        span{
            margin-right: 20px;
			line-height: 30px;
			display: inline-block;
        }
    }
}
@media screen and (min-width: 1445px) {
    .mobileListTitle,.mobileReturn,.infoListTitle,.moreCourse{
        display: none;
    }
    .StudentManagement{
        width: 1200px;
        margin: 40px auto 54px;
        background-color: #fff;
        overflow: hidden;
        .otherWrap{
            width: 100%;
            display: flex;
            align-items: center;
            flex-direction: column;
            h3{
                font-size: 24px;
                margin: 55px 0 0;
            }
            p{
                font-size: 14px;
                color: rgba(25,25,26,0.80);
            }
        }
        .page{
            margin: 42px 0 49px;
        }
    }
    // 学员列表
    .listTitleWrap,.listContWrap{
        width: 1000px;
        margin: 0 auto;
        li{
            display: flex;
            align-items: center;
            font-size: 14px;
			border-bottom: 2px solid #fafafa;
            .name{
                width: 15%;
            }
            .departmentText{
                width: 19%;
            }
            .typeText{
                width: 14%;
            }
            .totalTime{
                width: 38%;
                text-align: right;
            }
        }
    }
    .listTitleWrap{
        margin-bottom: 8px;
        li{
            padding: 18px 0 20px 10px;
            span{
                font-size: 12px;
            }
            .name{
                text-indent: 61px;
            }
        }
    }
    .listContWrap{
        min-height: 513px;
        li{
            cursor: pointer;
			padding: 18px 0 18px 10px;
            span{
                color: rgba(25,25,26,0.80);
            }
            .name{
                span:first-child{
                    margin-right: 42px;
                }
            }
        }
    }
    // 个人资料查询
    .personInfoCover{
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.80);
        display: flex;
        align-items: center;
        justify-content: center;
    
        position: fixed;
        top: 0;
        left: 0;
        .personInfoWrap{
            width: 70%;
            box-sizing: border-box;
            background-color: #fff;
            border-radius: 16px;
            padding: 0 60px;
    
            position: relative;
            .otherWrap{
                h3{
                    margin: 30px 0 0;
                }
                .timeSlot{
                    color: rgba(25,25,26,0.80);
                }
            }
        }
        .timeWrap{
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 10px 0 10px;
            p{
                color: rgba(25,25,26,0.80);
                font-size: 14px;
                margin-right: 20px;
            }
        }
        .timeSlot{
            text-align: center;
            color: #19191a;
            font-size: 14px;
            margin-bottom: 10px;
        }
        .page{
            margin: 15px 0 15px;
        }
        // 课程列表
        .infoList{
            padding: 0;
            min-height: 633px;
            li{
                cursor: pointer;
            }
            .courseWrap{
                padding: 18px 0;
                display: flex;
                border-bottom: 2px solid #fafafa;
            }
            span:first-child{
                width: 85%;
            }
            span:nth-child(2){
                text-align: left;
                width: 10%;
            }
            span{
                font-size: 14px;
                color: rgba(25,25,26,0.80);
                display: block;
            }
            .blueArrow{
                width: 5%;
                text-align: center;
            }
            .blueNormalArrow{
                transition: 0.5s;
                transform:rotate(0);
                -ms-transform:rotate(0); 	/* IE 9 */
                -moz-transform:rotate(0); 	/* Firefox */
                -webkit-transform:rotate(0); /* Safari 和 Chrome */
                -o-transform:rotate(0); 	/* Opera */
            }
            .blueTopArrow{
                transition: 0.5s;
                transform:rotate(180deg);
                -ms-transform:rotate(180deg); 	/* IE 9 */
                -moz-transform:rotate(180deg); 	/* Firefox */
                -webkit-transform:rotate(180deg); /* Safari 和 Chrome */
                -o-transform:rotate(180deg); 	/* Opera */
            }
            .credit{
                width: 10%;
                text-align: right;
            }
            ul{
                padding: 0 0 10px 25px;
                border-bottom: 2px solid #fafafa;
                max-height: 130px;
                overflow: hidden;
                overflow-y: scroll;
                li{
                    display: flex;
                    padding: 10px 0 0;
                }
                span:first-child{
                    width: 85%;
                }
                span:last-child{
                    text-align: left;
                    width: 15%;
                }
            }
        }
        // 关闭按钮
        .close{
            width: 24px;
            height: 24px;
            background: url('../../assets/img/delete_icon.svg') no-repeat center;
            background-size: 100%;
            cursor: pointer;
    
            position: absolute;
            top: 20px;
            right: 25px;
        }
    }
    // 查询
    .courseSearchWrap{
        width: 1000px;
        margin: 30px auto 20px;
        display: flex;
        align-items: center;
        .condition{
            display: flex;
            span{
                color: rgba(25,25,26,0.80);
                font-size: 12px;
            }
        }
        .TextInputBox,.courseNameBox,.dateBox{
            margin-right: 20px;
        }
        .dateBox{
            display: flex;
            align-items: center;
        }
        .query-clear span{
            margin-right: 20px;
            cursor: pointer;
        }
        .searchSty{
            color: #0061fe;
        }
    }
    .load{
        display: none;
    }
}
@media screen and (min-width: 1029px) and (max-width: 1440px){
    .mobileListTitle,.mobileReturn,.infoListTitle,.moreCourse{
        display: none;
    }
    .load{
        display: none;
    }
    .StudentManagement{
        width: 1100px;
        margin: 40px auto 54px;
        background-color: #fff;
        overflow: hidden;
        .otherWrap{
            width: 100%;
            display: flex;
            align-items: center;
            flex-direction: column;
            h3{
                font-size: 20px;
                margin: 55px 0 0;
            }
            p{
                font-size: 14px;
                color: rgba(25,25,26,0.80);
            }
        }
        .page{
            margin: 42px 0 49px;
        }
    }
    .listTitleWrap,.listContWrap{
        width: 1000px;
        margin: 0 auto;
        li{
            display: flex;
            align-items: center;
            font-size: 14px;
			border-bottom: 2px solid #fafafa;
            .name{
                width: 15%;
            }
            .departmentText{
                width: 19%;
            }
            .typeText{
                width: 14%;
            }
            .totalTime{
                width: 38%;
                text-align: right;
            }
            
        }
    }
    .listTitleWrap{
        margin-bottom: 8px;
        li{
            padding: 18px 0 20px 10px;
            span{
                font-size: 12px;
            }
            .name{
                text-indent: 61px;
            }
        }
    }
    .listContWrap{
        min-height: 513px;
        li{
            color: rgba(25,25,26,0.80);
			padding: 18px 0 18px 10px;
            cursor: pointer;
            .name{
                span:first-child{
                    margin-right: 42px;
                }
            }
        }
    }
    // 个人资料查询
    .personInfoCover{
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.80);
        display: flex;
        align-items: center;
        justify-content: center;
    
        position: fixed;
        top: 0;
        left: 0;
        .personInfoWrap{
            width: 70%;
            height: 100%;
            transform: scale(.95);
            padding: 0 40px;
            box-sizing: border-box;
            background-color: #fff;
            border-radius: 16px;
    
            position: relative;
            .otherWrap{
                p{
                    font-size: 13px;
                }
                h3{
                    margin: 15px 0 10px;
                }
                .timeSlot{
                    color: rgba(25,25,26,0.80);
                }
            }
        }
        .timeWrap{
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 0 0 10px;
            p{
                color: #19191a;
                font-size: 13px;
                margin-right: 40px;
            }
        }
        .page{
            margin: 5px 0 0;
        }
        // 课程列表
        .infoList{
            min-height: 430px;
            li{
                cursor: pointer;
            }
            .courseWrap{
                padding: 10px 0;
                display: flex;
                border-bottom: 1px solid #fafafa;
            }
            span:first-child{
                width: 85%;
            }
            span:nth-child(2){
                text-align: left;
                width: 10%;
            }
            span{
                font-size: 13px;
                color: rgba(25,25,26,0.80);
                display: block;
            }
            .blueArrow{
                width: 5%;
                text-align: center;
            }
            .blueNormalArrow{
                transition: 0.5s;
                transform:rotate(0);
                -ms-transform:rotate(0); 	/* IE 9 */
                -moz-transform:rotate(0); 	/* Firefox */
                -webkit-transform:rotate(0); /* Safari 和 Chrome */
                -o-transform:rotate(0); 	/* Opera */
            }
            .blueTopArrow{
                transition: 0.5s;
                transform:rotate(180deg);
                -ms-transform:rotate(180deg); 	/* IE 9 */
                -moz-transform:rotate(180deg); 	/* Firefox */
                -webkit-transform:rotate(180deg); /* Safari 和 Chrome */
                -o-transform:rotate(180deg); 	/* Opera */
            }
            .credit{
                width: 10%;
                text-align: right;
            }
            ul{
                padding: 0 0 5px 25px;
                border-bottom: 1px solid #fafafa;
                max-height: 90px;
                overflow: hidden;
                overflow-y: scroll;
                li{
                    display: flex;
                    padding: 5px 0 0;
                }
                span:first-child{
                    width: 85%;
                }
                span:last-child{
                    text-align: left;
                    width: 15%;
                }
            }
        }
        .close{
            width: 22px;
            height: 22px;
            background: url('../../assets/img/delete_icon.svg') no-repeat center;
            background-size: 100%;
            cursor: pointer;
    
            position: absolute;
            top: 15px;
            right: 20px;
        }
    }
    // 查询
    .courseSearchWrap{
        width: 1000px;
        margin: 30px auto 20px;
        display: flex;
        align-items: center;
        .condition{
            display: flex;
            span{
                color: rgba(25,25,26,0.80);
                font-size: 12px;
            }
        }
        .TextInputBox,.courseNameBox,.dateBox{
            margin-right: 20px;
        }
        .dateBox{
            display: flex;
            align-items: center;
        }
        .query-clear span{
            margin-right: 20px;
            cursor: pointer;
        }
        .searchSty{
            color: #0061fe;
        }
    }
}
.load{
	text-align: center;
}
// 滚动条
/*正常情况下滑块的宽高*/
.infoList ul::-webkit-scrollbar {
    width: 4px;
    height: 4px;
}
/*正常情况下滑块的样式*/
.infoList ul::-webkit-scrollbar-thumb {
    background-color: #C8CCD6;
    border-radius: 10px;
    -webkit-box-shadow: inset 1px 1px 0 rgba(0,0,0,.1);
}
/*鼠标悬浮在该类指向的控件上时滑块的样式*/
.infoList ul:hover::-webkit-scrollbar-thumb {
    background-color:  #C8CCD6;
    border-radius: 10px;
    -webkit-box-shadow: inset 1px 1px 0 rgba(0,0,0,.1);
}
/*鼠标悬浮在滑块上时滑块的样式*/
.infoList ul::-webkit-scrollbar-thumb:hover {
    background-color:  #C8CCD6;
    -webkit-box-shadow: inset 1px 1px 0 rgba(0,0,0,.1);
}
/*正常时候的主干部分*/
.infoList ul::-webkit-scrollbar-track {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px #EFEFEF;;
    background-color: transparent;
}
/*鼠标悬浮在滚动条上的主干部分*/
.infoList ul::-webkit-scrollbar-track:hover {
    -webkit-box-shadow: inset 0 0 6px #EFEFEF;
    background-color: rgba(0,0,0,.01);
}
</style>





// WEBPACK FOOTER //
// src/pages/ManagementCenter/ClassHourManagement.vue